import React, { useEffect, useState } from 'react';
import '../custom.css';
import '../style.css';
import Board from './Board';
import ScoreCard from './ScoreCard';
import LeaderBoard from './LeaderBoard';
import useGameBoard from './GameBoard';
import { submitScore, getRecentN } from "../lib/leaderboardService";

export default function Game() { 
  const [boardData, hotCell, gameOver, movePeg, resetBoard, pegsRemoved] = useGameBoard();  
  const [recentScores, setRecentScores] = useState();

  useEffect(() => {    
  }, [boardData]);
 
  useEffect(() => {
    (async () => {
      const recent = await getRecentN(10);
      setRecentScores(recent);
    })();
  }, []);
  
  const handleSubmit = async (playerScore) =>{
    const result = await submitScore(playerScore.player_name, playerScore.player_score);
    console.log("Score submission result:", result);
    const newRecentScores = await getRecentN(10);
    setRecentScores(newRecentScores);
    resetBoard();
  }

  function handleClick(data) {
    let currentIndex = parseInt(data);
    movePeg(currentIndex);
  }
  
  return (
    <div className="container fill">
      <h1 className="h1 game-title">Brainvita<sup class="beta-text">beta</sup></h1>
      <Board
        handleClick={handleClick}
        data={boardData}
        hotCell={hotCell}
      ></Board>
      <br />
      <ScoreCard
        currentScore={pegsRemoved}
        reset={resetBoard}
        submit={handleSubmit} 
        gameOver={gameOver}        
      ></ScoreCard>
      <br />
      <LeaderBoard
        key='recent-scores'
        title={'Recently Played'}
        scoresData={recentScores}
      ></LeaderBoard>      
    </div>

  );
}
